export default __webpack_public_path__ + "static/media/Free Legal Documents, Advice, Contracts & Forms - Heading.68350a5c.png";